<div class="list-picker-container">
  <ng-container [ngSwitch]="cfg().btnStyle">
    <a *ngSwitchCase="'link'" #linkTrigger (click)="op.toggle($event, linkTrigger)">
      <span *ngIf="cfg().btnLabel">{{ cfg().btnLabel }}</span>
      <mat-icon *ngIf="cfg().showBtnIcon" [svgIcon]="cfg().btnIcon"></mat-icon>
    </a>
    <button *ngSwitchDefault mat-button #btnTrigger (click)="op.toggle($event, btnTrigger)">
      {{ cfg().btnLabel }}
      <mat-icon *ngIf="cfg().showBtnIcon" [svgIcon]="cfg().btnIcon" iconPositionEnd></mat-icon>
    </button>
  </ng-container>

  <p-popover #op styleClass="list-selection-popover" appendTo="body">
    <div
      class="p-2"
      [matTooltip]="_selected?.length == 10 ? 'Maximum selection reached' : ''"
      matTooltipPosition="above"
    >
      <p-listbox
        [showToggleAll]="false"
        [options]="flatOptions()"
        [(ngModel)]="_selected"
        [group]="cfg().grouped"
        [filter]="cfg().searchFilter"
        [multiple]="cfg().multiple"
        [checkbox]="cfg().multiple"
        [filterPlaceholder]="cfg().filterPlaceholder"
        [style]="{ border: 'none', width: '260px' }"
        [dataKey]="cfg().dataKey"
        [listStyle]="{ 'max-height': cfg().maxHeight }"
        [optionLabel]="cfg().optionLabel"
        [optionValue]="cfg().optionValue"
        [optionDisabled]="isOptionDisabled()"
        (onChange)="onSelectionChange()"
      >
        <ng-template #group let-group>
          <div class="group-header">{{ group[cfg().groupKey] }}</div>
        </ng-template>
      </p-listbox>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
    <ng-template #footer>
      <div class="list-picker-footer" style="pointer-events: auto; opacity: 1">
        <button mat-button class="clear-btn" [disabled]="!_selected?.length" (click)="clearSelection(op)">
          {{ cfg().clearBtnText }}
        </button>
        <div class="selection-count" *ngIf="_selected?.length">
          {{ _selected.length }} of {{ cfg().maxSelection }} selected
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>
